import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";

const ITEMS = [
  "Integrity",
  "Transparency",
  "Accountability",
  "Long-Term Partnership",
  "Quality Controlled at Source",
  "Direct Factory Pricing",
  "Single Point of Accountability",
];

export const EditorialMarquee = () => (
  <section
    className="relative border-y border-[#2E7FE0]/15 bg-[#F4F7FC] py-7 overflow-hidden"
    data-testid="editorial-marquee"
  >
    <Marquee speed={32} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <div key={item} className="flex items-center" data-testid={`marquee-item-${i}`}>
          <span
            className={`font-display font-semibold text-2xl sm:text-4xl tracking-tight whitespace-nowrap px-6 ${
              i % 2 === 0 ? "text-[#0A1B33]" : "text-[#2E7FE0]"
            }`}
          >
            {item}
          </span>
          <Asterisk className="w-6 h-6 text-[#2E7FE0]" />
        </div>
      ))}
    </Marquee>
  </section>
);
